import React from "react";
import DateTime from "react-datetime";
import moment from "moment";
import { CalendarIcon } from "../svg";

import { DATE_FORMAT } from "../../constants";

export default function HvirfillDatePicker(props) {
  const { onChange, startDate, endDate, single = false } = props;

  function validEndDate(current) {
    if (!startDate) {
      return true;
    }
    return current.isSameOrAfter(startDate, "day");
  }

  function emitDateChange(name, inputDate) {
    onChange({
      target: {
        value: moment(inputDate).format(DATE_FORMAT),
        name,
      },
    });
  }

  if (single) {
    return (
      <div className="row mb-50">
        <div className="col date-picker-container position-relative">
          <DateTime
            value={startDate}
            timeFormat={false}
            viewMode="days"
            dateFormat={DATE_FORMAT}
            locale="is"
            inputProps={{ readOnly: true, placeholder: "Dagsetning" }}
            closeOnSelect
            closeOnTab
            required
            onChange={(inputDate) => emitDateChange("startDate", inputDate)}
          />
          <CalendarIcon />
        </div>
      </div>
    );
  }

  return (
    <div className="row mb-50">
      <div className="col date-picker-container position-relative">
        <DateTime
          value={startDate}
          timeFormat={false}
          viewMode="days"
          dateFormat={DATE_FORMAT}
          locale="is"
          inputProps={{ readOnly: true, placeholder: "Dagsetning frá" }}
          closeOnSelect
          closeOnTab
          required
          onChange={(inputDate) => emitDateChange("startDate", inputDate)}
        />
        <CalendarIcon />
      </div>
      <div className="col date-picker-container position-relative">
        <DateTime
          value={endDate}
          minDate={new Date()}
          timeFormat={false}
          viewMode="days"
          isValidDate={validEndDate}
          dateFormat={DATE_FORMAT}
          locale="is"
          inputProps={{ readOnly: true, placeholder: "Dagsetning til" }}
          closeOnSelect
          closeOnTab
          required
          onChange={(inputDate) => emitDateChange("endDate", inputDate)}
        />
        <CalendarIcon />
      </div>
    </div>
  );
}
